/* =========================================================================
   NOIR — Black theme
   黒の上に、幕が上がる。依存ライブラリなし。
   ========================================================================= */
(function () {
  'use strict';

  var CFG = window.NOIR || {};
  var MOTION = CFG.motion || {};
  var html = document.documentElement;
  var $ = function (s, c) { return (c || document).querySelector(s); };
  var $$ = function (s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); };
  var clamp = function (v, a, b) { return Math.max(a, Math.min(b, v)); };
  var lerp = function (a, b, t) { return a + (b - a) * t; };
  var wait = function (ms) { return new Promise(function (r) { setTimeout(r, ms); }); };

  var REDUCE = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var FINE = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
  if (REDUCE) html.classList.add('reduce-motion');

  var store = {
    get: function (k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } },
    set: function (k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} },
    del: function (k) { try { sessionStorage.removeItem(k); } catch (e) {} },
    lget: function (k) { try { return localStorage.getItem(k); } catch (e) { return null; } },
    lset: function (k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  };

  /* -----------------------------------------------------------------------
     幕：下から上がって画面を覆い、上へ抜けていく
     ----------------------------------------------------------------------- */
  var Curtain = {
    el: null,
    init: function () { this.el = $('[data-curtain]'); },
    // 画面を覆う（下からせり上がる）
    cover: function () {
      var el = this.el;
      if (!el) return Promise.resolve();
      el.classList.remove('is-lifting');
      el.classList.add('no-anim');
      el.style.clipPath = 'inset(100% 0 0 0)';
      void el.offsetWidth;
      el.classList.remove('no-anim');
      el.style.clipPath = '';
      el.classList.add('is-covering');
      return wait(760);
    },
    // 覆っている幕を上へ抜く
    lift: function () {
      var el = this.el;
      if (!el) return Promise.resolve();
      el.classList.add('is-covering');
      void el.offsetWidth;
      html.classList.remove('curtain-pending', 'intro-pending');
      el.classList.add('is-lifting');
      return wait(780).then(function () {
        el.classList.add('no-anim');
        el.classList.remove('is-covering', 'is-lifting');
        void el.offsetWidth;
        el.classList.remove('no-anim');
      });
    }
  };

  /* イントロ：生成りの幕に NOIR. とカウンター → 幕が上がる */
  function runIntro() {
    if (!html.classList.contains('intro-pending') || !Curtain.el) return false;
    html.classList.add('is-intro');
    var count = $('[data-intro-count]');
    var done = false;
    function finish() {
      if (done) return; done = true;
      store.set('noir-intro', '1');
      Curtain.lift().then(function () {
        html.classList.remove('is-intro', 'is-intro-shown');
        document.dispatchEvent(new CustomEvent('noir:ready'));
      });
    }
    var skip = $('[data-intro-skip]');
    if (skip) skip.addEventListener('click', finish);
    window.addEventListener('keydown', finish, { once: true });
    setTimeout(function () { html.classList.add('is-intro-shown'); }, 60);
    var start = performance.now(), dur = 1700;
    (function tick(now) {
      if (done) return;
      var t = clamp((now - start) / dur, 0, 1);
      var eased = 1 - Math.pow(1 - t, 3);
      if (count) count.textContent = String(Math.round(eased * 100)).padStart(3, '0');
      if (t < 1) requestAnimationFrame(tick); else setTimeout(finish, 350);
    })(start);
    return true;
  }

  /* ページ遷移 */
  function initTransitions() {
    var enabled = MOTION.transition && !REDUCE && Curtain.el;
    if (html.classList.contains('curtain-pending')) {
      store.del('noir-curtain');
      if (enabled) Curtain.lift(); else html.classList.remove('curtain-pending');
    }
    window.addEventListener('pageshow', function (e) {
      if (e.persisted && Curtain.el) { Curtain.el.classList.remove('is-covering', 'is-lifting'); html.classList.remove('curtain-pending'); }
    });
    if (!enabled) return;
    document.addEventListener('click', function (e) {
      if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
      var a = e.target.closest('a');
      if (!a || !a.href || a.target === '_blank' || a.hasAttribute('download') || a.dataset.noCurtain != null) return;
      if (a.closest('[data-cart-open], [data-search-open]')) return;
      var url = new URL(a.href, location.href);
      if (url.origin !== location.origin) return;
      if (url.pathname === location.pathname && url.search === location.search && url.hash) return;
      if (/\/(checkout|cart\/|account\/logout)/.test(url.pathname) && url.pathname !== '/cart') return;
      e.preventDefault();
      Curtain.cover().then(function () {
        store.set('noir-curtain', '1');
        location.href = url.href;
      });
    });
  }

  /* -----------------------------------------------------------------------
     ドットカーソル
     ----------------------------------------------------------------------- */
  function initCursor() {
    var el = $('[data-cursor-dot]');
    if (!el || !MOTION.cursor || REDUCE || !FINE) return;
    html.classList.add('has-cursor');
    var label = $('[data-cursor-label]', el);
    var x = -100, y = -100, tx = -100, ty = -100;
    window.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; el.classList.remove('is-hidden'); }, { passive: true });
    document.addEventListener('pointerleave', function () { el.classList.add('is-hidden'); });
    window.addEventListener('pointerdown', function () { el.classList.add('is-down'); });
    window.addEventListener('pointerup', function () { el.classList.remove('is-down'); });
    document.addEventListener('pointerover', function (e) {
      var row = e.target.closest('[data-marquee-row]');
      var t = e.target.closest('[data-cursor], a, button, summary, label');
      el.classList.toggle('is-grab', !!row && !t);
      el.classList.toggle('is-hover', !!t);
      label.textContent = t && t.dataset.cursor ? t.dataset.cursor : (row ? 'DRAG' : '');
    });
    (function frame() {
      x = lerp(x, tx, 0.25); y = lerp(y, ty, 0.25);
      el.style.transform = 'translate3d(' + x + 'px,' + y + 'px,0)';
      requestAnimationFrame(frame);
    })();
  }

  /* -----------------------------------------------------------------------
     文字がせり上がる／写真が幕を上げるように現れる
     ----------------------------------------------------------------------- */
  function splitText(el) {
    if (el.dataset.splitReady) return;
    el.dataset.splitReady = '1';
    var text = el.textContent.replace(/\s+/g, ' ').trim();
    el.setAttribute('aria-label', text);
    el.textContent = '';
    var ci = 0;
    text.split(' ').forEach(function (word, wi, arr) {
      var w = document.createElement('span');
      // 和文はどこで改行してもいいので、単語ごとの改行禁止をかけない
      w.className = /[　-鿿＀-￯]/.test(word) ? 'split-word split-word--cjk' : 'split-word';
      w.setAttribute('aria-hidden', 'true');
      // 和文は読点・句点の後ろでだけ折り返す（「輪郭を／描く。」のような泣き別れを防ぐ）
      // 1かたまりが長すぎる場合（商品名など）は、はみ出さないよう普通に折り返す
      var phrases = /[\u3000-\u9fff\uff00-\uffef]/.test(word) ? word.match(/[^、。，．]*[、。，．]?/g).filter(Boolean) : [word];
      phrases.forEach(function (ph) {
        var holder = w;
        if (phrases.length > 1 && ph.length <= 14) {
          holder = document.createElement('span');
          holder.className = 'split-phrase';
          w.appendChild(holder);
        }
        Array.from(ph).forEach(function (ch) {
          var c = document.createElement('span');
          c.className = 'split-char';
          c.style.setProperty('--ci', ci++);
          c.textContent = ch;
          holder.appendChild(c);
        });
      });
      el.appendChild(w);
      if (wi < arr.length - 1) el.appendChild(document.createTextNode(' '));
    });
  }

  function initReveals() {
    var splits = $$('[data-split]');
    var reveals = $$('[data-reveal]');
    if (REDUCE || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) { el.classList.add('is-revealed'); });
      return;
    }
    splits.forEach(splitText);
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        var el = en.target;
        io.unobserve(el);
        if (el.hasAttribute('data-split')) el.classList.add('is-split');
        if (el.hasAttribute('data-reveal')) el.classList.add('is-revealed');
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    function observe() { splits.concat(reveals).forEach(function (el) { io.observe(el); }); }
    // イントロ中は幕の後ろで先に出てしまわないよう待つ
    if (html.classList.contains('is-intro')) document.addEventListener('noir:ready', observe, { once: true });
    else observe();
  }

  /* PRODUCT / OUTFIT 切替 */
  function initViewToggle() {
    $$('[data-view-scope]').forEach(function (scope) {
      var btns = $$('[data-view-set]', scope);
      if (!btns.length) return;
      function set(v) {
        scope.setAttribute('data-view', v);
        btns.forEach(function (b) { b.setAttribute('aria-pressed', b.dataset.viewSet === v ? 'true' : 'false'); });
      }
      var saved = store.lget('noir-view');
      if (saved) set(saved);
      btns.forEach(function (b) {
        b.addEventListener('click', function () { set(b.dataset.viewSet); store.lset('noir-view', b.dataset.viewSet); });
      });
    });
  }

  /* -----------------------------------------------------------------------
     ヒーロー：写真が時間差で幕開け。マウスで視差、スクロールで沈む
     ----------------------------------------------------------------------- */
  function initHero() {
    var hero = $('[data-hero]');
    if (!hero) return;
    var panels = $$('[data-hero-panel]', hero);
    var medias = $$('[data-hero-media]', hero);
    var title = $('.hero__title', hero);
    var video = $('.hero__video', hero);
    // 動きを減らす設定の人には動画を再生しない
    if (video && REDUCE) { video.removeAttribute('autoplay'); video.pause(); }
    function ready() { setTimeout(function () { hero.classList.add('is-ready'); }, 60); }
    if (REDUCE) { hero.classList.add('is-ready'); return; }
    if (html.classList.contains('is-intro')) document.addEventListener('noir:ready', ready, { once: true });
    else ready();

    // スマホ：1枚ずつ切り替える
    var mobile = window.matchMedia('(max-width: 989px)');
    var current = 0;
    if (panels.length) panels[0].classList.add('is-active');
    setInterval(function () {
      if (!mobile.matches || panels.length < 2 || document.hidden) return;
      var prev = panels[current];
      current = (current + 1) % panels.length;
      panels.forEach(function (p) { p.classList.remove('is-leaving'); });
      prev.classList.remove('is-active'); prev.classList.add('is-leaving');
      panels[current].classList.add('is-active');
    }, 4200);

    // マウスの位置でパネルが少しずつずれる
    var mx = 0, my = 0, cx = 0, cy = 0, sy = 0;
    if (FINE) {
      hero.addEventListener('pointermove', function (e) {
        var r = hero.getBoundingClientRect();
        mx = (e.clientX - r.left) / r.width - 0.5;
        my = (e.clientY - r.top) / r.height - 0.5;
      }, { passive: true });
      hero.addEventListener('pointerleave', function () { mx = 0; my = 0; });
    }
    var visible = true;
    new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }).observe(hero);
    (function frame() {
      if (visible) {
        cx = lerp(cx, mx, 0.06); cy = lerp(cy, my, 0.06);
        var h = hero.offsetHeight;
        sy = clamp(window.scrollY / h, 0, 1);
        medias.forEach(function (m, i) {
          var depth = (i - (medias.length - 1) / 2) || 0.5;
          m.style.setProperty('--px', (cx * 18 * depth).toFixed(2) + 'px');
          m.style.setProperty('--py', (cy * 12).toFixed(2) + 'px');
          m.style.setProperty('--sy', (sy * h * (0.18 + i * 0.06)).toFixed(1) + 'px');
        });
        if (title) title.style.setProperty('--ty', (sy * h * -0.25).toFixed(1) + 'px');
        if (video) video.style.setProperty('--sy', (sy * h * 0.2).toFixed(1) + 'px');
      }
      requestAnimationFrame(frame);
    })();
  }

  /* -----------------------------------------------------------------------
     ARCHIVE：流れ続ける帯。掴んで投げられ、スクロールの速さで加速する
     ----------------------------------------------------------------------- */
  function initMarquee() {
    $$('[data-marquee]').forEach(function (section) {
      var base = Number(section.dataset.speed) || 35;
      var rows = $$('[data-marquee-row]', section).map(function (row) {
        return { row: row, track: $('[data-marquee-track]', row), dir: Number(row.dataset.dir) || -1, x: 0, v: 0, drag: false, half: 0 };
      });
      var boost = 0, lastY = window.scrollY, visible = false, last = performance.now();

      function measure() { rows.forEach(function (r) { r.half = r.track.scrollWidth / 2; }); }
      measure();
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);

      window.addEventListener('scroll', function () {
        var y = window.scrollY;
        boost = clamp(boost + Math.abs(y - lastY) * 0.6, 0, 900);
        lastY = y;
      }, { passive: true });

      rows.forEach(function (r) {
        var sx, ox, lx, lt, moved = false, pid = null;
        r.row.addEventListener('click', function (e) { if (moved) { e.preventDefault(); e.stopPropagation(); } }, true);
        r.row.addEventListener('pointerdown', function (e) {
          if (e.button !== 0) return;
          pid = e.pointerId; r.drag = true; moved = false;
          sx = lx = e.clientX; ox = r.x; lt = performance.now(); r.v = 0;
          r.row.classList.add('is-dragging');
        });
        r.row.addEventListener('pointermove', function (e) {
          if (!r.drag || e.pointerId !== pid) return;
          var dx = e.clientX - sx;
          if (!moved && Math.abs(dx) > 6) { moved = true; try { r.row.setPointerCapture(pid); } catch (err) {} }
          if (!moved) return;
          r.x = ox + dx;
          var now = performance.now();
          r.v = (e.clientX - lx) / Math.max(1, now - lt) * 1000;
          lx = e.clientX; lt = now;
        });
        function end() {
          if (!r.drag) return;
          r.drag = false; r.row.classList.remove('is-dragging');
          setTimeout(function () { moved = false; }, 0);
        }
        r.row.addEventListener('pointerup', end);
        r.row.addEventListener('pointercancel', end);
        r.row.addEventListener('pointerleave', function () { if (!moved) end(); });
        r.row.addEventListener('dragstart', function (e) { e.preventDefault(); });
      });

      new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { rootMargin: '100px' }).observe(section);

      (function frame(now) {
        var dt = Math.min(0.05, (now - last) / 1000); last = now;
        boost *= 0.92;
        if (visible) {
          rows.forEach(function (r) {
            if (!r.half) return;
            if (!r.drag) {
              var auto = REDUCE ? 0 : r.dir * (base + boost);
              r.v = lerp(r.v, auto, 0.05);
              r.x += r.v * dt;
            }
            // 帯は2セット並んでいるので、半分ずれたら戻す（途切れずに流れ続ける）
            if (r.x <= -r.half) r.x += r.half;
            if (r.x > 0) r.x -= r.half;
            r.track.style.transform = 'translate3d(' + r.x.toFixed(2) + 'px,0,0)';
          });
        }
        requestAnimationFrame(frame);
      })(last);
    });
  }

  /* -----------------------------------------------------------------------
     LOOK：縦スクロールで横に流れる
     ----------------------------------------------------------------------- */
  function initLook() {
    $$('[data-look]').forEach(function (section) {
      var track = $('[data-look-track]', section);
      var counter = $('[data-look-current]', section);
      var panels = $$('.look__panel', track).filter(function (p) { return !p.classList.contains('look__panel--end'); });
      var pad = function (n) { return (n < 10 ? '0' : '') + n; };
      var desktop = window.matchMedia('(min-width: 990px)');
      function setCounter(i) { if (counter) counter.textContent = pad(clamp(i, 1, panels.length)); }
      function measure() {
        if (!desktop.matches || REDUCE) { section.style.height = ''; track.style.transform = ''; return; }
        section.style.height = (track.scrollWidth - window.innerWidth + window.innerHeight) + 'px';
        update();
      }
      function update() {
        if (!desktop.matches || REDUCE) return;
        var r = section.getBoundingClientRect();
        var dist = track.scrollWidth - window.innerWidth;
        var p = clamp(-r.top / Math.max(1, section.offsetHeight - window.innerHeight), 0, 1);
        track.style.transform = 'translate3d(' + (-p * dist).toFixed(1) + 'px,0,0)';
        setCounter(Math.round(p * (panels.length - 1)) + 1);
      }
      track.addEventListener('scroll', function () {
        if (desktop.matches) return;
        setCounter(Math.round(track.scrollLeft / Math.max(1, track.scrollWidth - track.clientWidth) * (panels.length - 1)) + 1);
      }, { passive: true });
      window.addEventListener('scroll', function () { requestAnimationFrame(update); }, { passive: true });
      window.addEventListener('resize', measure);
      window.addEventListener('load', measure);
      measure();
    });
  }

  /* -----------------------------------------------------------------------
     カテゴリ索引：ホバーで写真が下から現れ、カーソルについてくる
     ----------------------------------------------------------------------- */
  function initIndex() {
    var float = $('[data-index-float]');
    if (!float || !FINE || REDUCE) return;
    var img = $('[data-index-img]', float);
    var x = 0, y = 0, tx = 0, ty = 0, fs = 0, tfs = 0, running = false;
    function frame() {
      x = lerp(x, tx, 0.14); y = lerp(y, ty, 0.14); fs = lerp(fs, tfs, 0.12);
      var w = float.offsetWidth, h = float.offsetHeight;
      float.style.transform = 'translate3d(' + (x - w / 2) + 'px,' + (y - h / 2) + 'px,0) rotate(' + ((tx - x) * 0.02).toFixed(2) + 'deg)';
      float.style.setProperty('--fs', fs.toFixed(2));
      if (Math.abs(fs - tfs) > 0.2 || Math.abs(x - tx) > 0.5) requestAnimationFrame(frame); else running = false;
    }
    function kick() { if (!running) { running = true; requestAnimationFrame(frame); } }
    $$('[data-index-link]').forEach(function (link) {
      link.addEventListener('pointerenter', function (e) {
        if (!link.dataset.preview) return;
        if (img.getAttribute('src') !== link.dataset.preview) { img.src = link.dataset.preview; fs = 0; }
        if (tfs === 0) { x = e.clientX; y = e.clientY; }
        tfs = 100; kick();
      });
      link.addEventListener('pointerleave', function () { tfs = 0; kick(); });
    });
    window.addEventListener('pointermove', function (e) { tx = e.clientX; ty = e.clientY; if (tfs) kick(); }, { passive: true });
  }

  /* -----------------------------------------------------------------------
     メニュー（生成りの幕が上から降りる）
     ----------------------------------------------------------------------- */
  var menuState = { open: false };
  function openMenu() {
    var menu = $('[data-menu]'), btn = $('[data-menu-toggle]');
    if (!menu || menuState.open) return;
    menuState.open = true;
    html.classList.add('menu-open');
    btn.setAttribute('aria-expanded', 'true');
    menu.setAttribute('aria-hidden', 'false');
    menu.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    setTimeout(function () { var first = $('[data-menu-link]', menu); if (first) first.focus({ preventScroll: true }); }, 400);
  }
  function closeMenu() {
    var menu = $('[data-menu]'), btn = $('[data-menu-toggle]');
    if (!menu || !menuState.open) return;
    menuState.open = false;
    html.classList.remove('menu-open');
    btn.setAttribute('aria-expanded', 'false');
    menu.setAttribute('aria-hidden', 'true');
    menu.classList.remove('is-open');
    document.body.style.overflow = '';
  }
  function initMenu() {
    var btn = $('[data-menu-toggle]');
    if (!btn) return;
    btn.addEventListener('click', function () { menuState.open ? closeMenu() : openMenu(); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') { closeMenu(); closeSearch(); closeCart(); } });
  }

  /* ヘッダー：下にスクロールで隠れ、上で現れる */
  function initHeader() {
    var header = $('[data-header]');
    if (!header) return;
    var lastY = window.scrollY;
    window.addEventListener('scroll', function () {
      var y = window.scrollY;
      header.classList.toggle('is-hidden', y > lastY && y > 200 && !menuState.open);
      header.classList.toggle('is-scrolled', y > 30);
      lastY = y;
    }, { passive: true });
  }

  /* 検索 */
  function closeSearch() { var s = $('[data-search]'); if (s) { s.classList.remove('is-open'); s.setAttribute('aria-hidden', 'true'); } }
  function initSearch() {
    var s = $('[data-search]');
    if (!s) return;
    $$('[data-search-open]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        s.classList.add('is-open'); s.setAttribute('aria-hidden', 'false');
        setTimeout(function () { var i = $('input[type="search"]', s); if (i) i.focus(); }, 200);
      });
    });
    $$('[data-search-close]', s).forEach(function (b) { b.addEventListener('click', closeSearch); });
  }

  /* -----------------------------------------------------------------------
     カート
     ----------------------------------------------------------------------- */
  function formatMoney(cents) {
    var fmt = CFG.moneyFormat || '¥{{amount_no_decimals}}';
    var n = (cents || 0) / 100;
    var withDelim = function (v, d) { return v.toFixed(d).replace(/\B(?=(\d{3})+(?!\d))/g, ','); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, k) {
      if (k === 'amount_no_decimals') return withDelim(Math.round(n), 0);
      if (k === 'amount_with_comma_separator') return n.toFixed(2).replace('.', ',');
      return withDelim(n, 2);
    });
  }
  function priceText(cents) { return cents === 0 && CFG.priceTba ? CFG.priceTba : formatMoney(cents); }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c]; }); }

  var Cart = {
    drawer: null,
    init: function () {
      this.drawer = $('[data-cart-drawer]');
      var self = this;
      $$('[data-cart-open]').forEach(function (a) {
        a.addEventListener('click', function (e) { if (!self.drawer) return; e.preventDefault(); self.open(); });
      });
      $$('[data-cart-close]').forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      if (this.drawer) {
        this.drawer.addEventListener('click', function (e) {
          var btn = e.target.closest('[data-line-change]');
          if (!btn) return;
          e.preventDefault();
          self.change(+btn.dataset.line, +btn.dataset.qty);
        });
      }
    },
    fetch: function () {
      return fetch((CFG.routes && CFG.routes.cart || '/cart') + '.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
    },
    render: function (cart) {
      $$('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
      var total = $('[data-cart-total]'); if (total) total.textContent = formatMoney(cart.total_price);
      var box = $('[data-cart-items]');
      if (!box) return;
      if (!cart.items.length) { box.innerHTML = '<p class="drawer__empty">' + escapeHtml(CFG.strings && CFG.strings.cartEmpty) + '</p>'; return; }
      box.innerHTML = cart.items.map(function (it, i) {
        var line = i + 1;
        var img = it.image ? '<a class="line__media" href="' + escapeHtml(it.url) + '"><img src="' + escapeHtml(it.image) + '" alt="" loading="lazy"></a>' : '<span class="line__media"></span>';
        var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<p class="line__variant">' + escapeHtml(it.variant_title) + '</p>' : '';
        return '<div class="line">' + img +
          '<div class="line__info"><a class="line__title" href="' + escapeHtml(it.url) + '">' + escapeHtml(it.product_title) + '</a>' + variant +
          '<p class="line__price">' + priceText(it.final_line_price) + '</p>' +
          '<div class="line__qty"><button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity - 1) + '" aria-label="-">−</button><span>' + it.quantity + '</span>' +
          '<button type="button" data-line-change data-line="' + line + '" data-qty="' + (it.quantity + 1) + '" aria-label="+">+</button></div></div>' +
          '<a href="#" class="line__remove" data-line-change data-line="' + line + '" data-qty="0">' + escapeHtml(CFG.strings && CFG.strings.remove) + '</a></div>';
      }).join('');
    },
    open: function () {
      var self = this;
      closeMenu();
      this.fetch().then(function (c) { self.render(c); }).catch(function () {});
      this.drawer.classList.add('is-open');
      this.drawer.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function () { var p = $('.drawer__panel', self.drawer); if (p) p.focus(); }, 50);
    },
    close: function () {
      if (!this.drawer) return;
      this.drawer.classList.remove('is-open');
      this.drawer.setAttribute('aria-hidden', 'true');
      if (!menuState.open) document.body.style.overflow = '';
    },
    change: function (line, qty) {
      var self = this;
      return fetch((CFG.routes && CFG.routes.cartChange || '/cart/change') + '.js', {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ line: line, quantity: Math.max(0, qty) })
      }).then(function (r) { return r.json(); }).then(function (c) { self.render(c); });
    },
    add: function (form) {
      var self = this;
      return fetch((CFG.routes && CFG.routes.cartAdd || '/cart/add') + '.js', {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }).then(function (r) {
        return r.json().then(function (j) { if (!r.ok) throw j; return j; });
      }).then(function () { return self.fetch(); }).then(function (c) { self.render(c); return c; });
    }
  };
  function closeCart() { Cart.close(); }

  /* -----------------------------------------------------------------------
     商品詳細
     ----------------------------------------------------------------------- */
  function initProduct() {
    var root = $('[data-product]');
    if (!root) return;
    var form = $('[data-product-form]', root) || $('#ProductForm');
    var msg = $('[data-product-msg]', root);
    var addBtn = $('[data-add-button]', root);
    var variants = [];
    try { variants = JSON.parse(($('[data-product-json]', root) || {}).textContent || '[]'); } catch (e) {}

    // バリエーション切替
    if (form && variants.length > 1) {
      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option]')) return;
        var chosen = $$('fieldset[data-option-index]', form).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = variants.find(function (vv) { return vv.options.every(function (o, i) { return o === chosen[i]; }); });
        if (!v) return;
        $('[data-variant-id]', form).value = v.id;
        var sku = $('[data-sku]', root); if (sku) sku.textContent = v.sku || '';
        $$('[data-price]', root).forEach(function (p) { p.innerHTML = '<span class="price__now">' + escapeHtml(priceText(v.price)) + '</span>'; });
        $$('[data-fill]', root).forEach(function (b) { b.disabled = !v.available; });
        var label = $('[data-add-label]', root);
        if (label) label.textContent = v.available ? 'BUY' : (CFG.strings && CFG.strings.soldOut) || 'SOLD OUT';
        var url = new URL(location.href); url.searchParams.set('variant', v.id); history.replaceState(null, '', url);
      });
    }

    // カートに入れる
    if (form && Cart.drawer) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        if (addBtn) addBtn.setAttribute('aria-busy', 'true');
        Cart.add(form).then(function () {
          if (msg) msg.textContent = (CFG.strings && CFG.strings.added) || '';
          Cart.open();
        }).catch(function (err) {
          if (msg) msg.textContent = (err && (err.description || err.message)) || 'Error';
        }).then(function () { if (addBtn) addBtn.removeAttribute('aria-busy'); });
      });
    }

    // BUY ボタンが画面外に出たら、下に追従バーを出す
    var bar = $('[data-buybar]', root);
    if (bar && addBtn && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (en) {
        var out = !en[0].isIntersecting && en[0].boundingClientRect.top < 0;
        bar.classList.toggle('is-visible', out);
        bar.setAttribute('aria-hidden', out ? 'false' : 'true');
      }).observe(addBtn);
    }

    // スマホのギャラリー枚数表示
    var track = $('[data-gallery-track]', root), cur = $('[data-gallery-current]', root);
    if (track && cur) {
      track.addEventListener('scroll', function () {
        cur.textContent = Math.round(track.scrollLeft / Math.max(1, track.clientWidth)) + 1;
      }, { passive: true });
    }
  }

  /* コレクションの並び替え・絞り込みは選んだら即反映 */
  function initCollectionForm() {
    var form = $('[data-collection-form]');
    if (!form) return;
    form.addEventListener('change', function () {
      var params = new URLSearchParams(new FormData(form));
      Array.from(params.keys()).forEach(function (k) { if (params.get(k) === '') params.delete(k); });
      location.search = params.toString();
    });
  }


  /* -----------------------------------------------------------------------
     お気に入り（お客さんのブラウザに保存。ログイン不要）
     ----------------------------------------------------------------------- */
  var Fav = {
    key: 'noir-fav',
    list: function () { try { return JSON.parse(localStorage.getItem(this.key) || '[]'); } catch (e) { return []; } },
    save: function (l) { try { localStorage.setItem(this.key, JSON.stringify(l)); } catch (e) {} },
    has: function (h) { return this.list().indexOf(h) > -1; },
    toggle: function (h) {
      var l = this.list(), i = l.indexOf(h);
      if (i > -1) l.splice(i, 1); else l.unshift(h);
      this.save(l); this.sync(); return i === -1;
    },
    sync: function () {
      var l = this.list();
      $$('[data-fav]').forEach(function (b) { b.setAttribute('aria-pressed', l.indexOf(b.dataset.handle) > -1 ? 'true' : 'false'); });
      $$('[data-fav-count]').forEach(function (el) { el.textContent = l.length; });
    },
    init: function () {
      var self = this;
      document.addEventListener('click', function (e) {
        var b = e.target.closest('[data-fav]');
        if (!b) return;
        e.preventDefault(); e.stopPropagation();
        var on = self.toggle(b.dataset.handle);
        b.classList.remove('is-pop'); void b.offsetWidth; if (on) b.classList.add('is-pop');
        var card = b.closest('[data-fav-card]');
        if (card && !on) { card.remove(); self.renderEmpty(); }
      });
      this.sync();
      this.renderPage();
    },
    renderEmpty: function () {
      var box = $('[data-fav-list]');
      if (box && !box.children.length) box.innerHTML = '<p class="collection__empty">' + escapeHtml(box.dataset.empty) + '</p>';
    },
    renderPage: function () {
      var box = $('[data-fav-list]'), self = this;
      if (!box) return;
      var l = this.list();
      if (!l.length) { this.renderEmpty(); return; }
      Promise.all(l.map(function (h) {
        return fetch('/products/' + encodeURIComponent(h) + '.js').then(function (r) { return r.ok ? r.json() : null; }).catch(function () { return null; });
      })).then(function (items) {
        box.innerHTML = items.filter(Boolean).map(function (p) {
          var img = p.featured_image ? p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600' : '';
          var price = p.price === 0 ? escapeHtml(box.dataset.tba) : formatMoney(p.price);
          return '<article class="card" data-fav-card>' +
            '<a class="card__link" href="/products/' + escapeHtml(p.handle) + '" data-cursor="VIEW">' +
            '<div class="card__media">' + (img ? '<img class="card__img card__img--product" src="' + escapeHtml(img) + '" alt="' + escapeHtml(p.title) + '" loading="lazy">' : '') + '</div>' +
            '<div class="card__meta"><h3 class="card__title">' + escapeHtml(p.title) + '</h3><span class="card__type">' + escapeHtml(p.type || '') + '</span><span class="price">' + price + '</span></div></a>' +
            '<button type="button" class="fav fav--card" data-fav data-handle="' + escapeHtml(p.handle) + '" aria-pressed="true" aria-label="fav"><svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.5s-7.5-4.6-9.2-9.3C1.6 7.8 3.8 4.5 7.1 4.5c2 0 3.6 1.1 4.9 2.9 1.3-1.8 2.9-2.9 4.9-2.9 3.3 0 5.5 3.3 4.3 6.7-1.7 4.7-9.2 9.3-9.2 9.3Z"/></svg></button>' +
            '</article>';
        }).join('');
        self.renderEmpty();
      });
    }
  };


  /* -----------------------------------------------------------------------
     公式LINE追加ポップアップ
     ブラウザの「戻る」（PCは画面上端からマウスが出た時も）で1回だけ。一定期間は出さない
     ----------------------------------------------------------------------- */
  var LinePopup = {
    el: null, shown: false,
    key: 'noir-linepop',
    blocked: function () {
      try {
        var v = localStorage.getItem(this.key);
        if (!v) return false;
        if (v === 'joined') return true;
        var days = Number(this.el.dataset.days) || 7;
        return Date.now() - Number(v) < days * 864e5;
      } catch (e) { return false; }
    },
    mark: function (v) { try { localStorage.setItem(this.key, v); } catch (e) {} },
    open: function () {
      if (this.shown || this.blocked()) return false;
      this.shown = true;
      this.mark(String(Date.now()));
      this.el.classList.add('is-open');
      this.el.setAttribute('aria-hidden', 'false');
      var b = $('[data-line-popup-go]', this.el); if (b) setTimeout(function () { b.focus({ preventScroll: true }); }, 300);
      return true;
    },
    close: function () { this.el.classList.remove('is-open'); this.el.setAttribute('aria-hidden', 'true'); },
    init: function () {
      var self = this;
      this.el = $('[data-line-popup]');
      if (!this.el || this.blocked()) return;
      $$('[data-line-popup-close]', this.el).forEach(function (b) { b.addEventListener('click', function () { self.close(); }); });
      var go = $('[data-line-popup-go]', this.el);
      if (go) go.addEventListener('click', function () { self.mark('joined'); self.close(); });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
      // 「戻る」を1回だけ受け止める：ページに1段だけ履歴を積み、戻る操作で消費されたら表示
      // 2回目の「戻る」は普通に前のページへ戻れる
      try {
        history.pushState({ noirLinePop: true }, '', location.href);
        window.addEventListener('popstate', function () {
          if (!self.open()) history.back();
        }, { once: true });
      } catch (e) {}
      // PC：マウスが画面の上端から外に出た時（タブを閉じる・アドレスバーへ向かう動き）
      if (FINE) {
        setTimeout(function () {
          document.addEventListener('mouseout', function (e) {
            if (!e.relatedTarget && e.clientY <= 0) self.open();
          });
        }, 8000);
      }
    }
  };
  // LINEへのリンクを押した人には、もうポップアップを出さない
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href*="lin.ee"], a[href*="line.me"]');
    if (a) { try { localStorage.setItem('noir-linepop', 'joined'); } catch (err) {} }
  }, true);

  /* -----------------------------------------------------------------------
     起動
     ----------------------------------------------------------------------- */
  function boot() {
    Curtain.init();
    var intro = MOTION.intro && !REDUCE && runIntro();
    if (!intro) html.classList.remove('intro-pending');
    initTransitions();
    initCursor();
    initReveals();
    initViewToggle();
    initHero();
    initMarquee();
    initLook();
    initIndex();
    initMenu();
    initHeader();
    initSearch();
    Cart.init();
    initProduct();
    initCollectionForm();
    Fav.init();
    LinePopup.init();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
